import React, { useContext, useEffect, useState } from "react";
import { Alert, Table } from "../../../layout";
import { Avatar, IconButton, Tooltip } from "@mui/material";
import {
  ClearRounded,
  EditRounded,
  VisibilityRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../controls";
import { AppContext } from "../../../App";
import { API, action, controller } from "../../../api/api";
import { formatDate } from "hooks";

const Suppliers = () => {
  const navigate = useNavigate();
  const { authUser, setLoader, access } = useContext(AppContext);
  const [splrs, setSplrs] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    if (authUser.id) {
      setLoader(true);
      API(controller.Supplier + action.GetAllByOrg).get((res) => {
        res && res.status === 200 && setSplrs([...res.result]);
        setLoader(false);
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  const handleAddEdit = (id) => {
    navigate(`/supplier_form/${id || ""}`);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure!",
      subTitle: "You want to delete this supplier profile?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Deleted Successfully",
              subTitle: res.msg,
            });
            setSplrs((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res.msg,
            });
          }
        };
        API(controller.Supplier).Delete(id, onComplete);
      },
    });
  };

  const handleViewSupplier = (id) => {
    navigate(`/view_supplier/${id}`);
  };

  const ActionComp = (val) => (
    <div className="border !border-gray-100 flex gap-2 p-[3px] shadow-sm rounded-[12px] w-fit">
      <Tooltip title="View">
        <IconButton
          onClick={() => handleViewSupplier(val.id)}
          size="small"
          color="primary"
        >
          <VisibilityRounded className="!text-[18px]" />
        </IconButton>
      </Tooltip>
      {access?.supplier?.edit && (
        <Tooltip title="Edit">
          <IconButton
            onClick={() => handleAddEdit(val.id)}
            size="small"
            color="primary"
          >
            <EditRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
      {access?.supplier?.delete && (
        <Tooltip title="Delete">
          <IconButton
            onClick={() => handleDlt(val.id)}
            size="small"
            color="error"
          >
            <ClearRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );

  const HeaderComp = () =>
    access?.supplier?.create && (
      <Button onClick={() => handleAddEdit()}>Add Supplier</Button>
    );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "splr", label: "Supplier" },
          { id: "contact", label: "Contact" },
          { id: "defMarkup", label: "Default Markup (%)" },
          { id: "prod", label: "Number of Products" },
          { id: "date", label: "Date" },
          { id: "actions", label: "Actions" },
        ]}
        tblData={splrs.map((j) => {
          return {
            ...j,
            splr: (
              <div className="flex gap-[15px] items-center mb-[5px] mt-[5px]">
                <Avatar src={j.photo} className="shadow-lg" />
                <div className="grid">
                  <span className="">{j.splrName}</span>
                  <span className="text-[12px]">{j.company}</span>
                </div>
              </div>
            ),
            contact: (
              <div className="grid">
                {j.email && (
                  <a
                    className="text-[14px] primary-color cursor-pointer mb-[3px]"
                    href={`mailto:${j.email}`}
                  >
                    ✉️ {j.email}
                  </a>
                )}
                <a
                  className="text-[14px] primary-color cursor-pointer"
                  href={`tel:1955206146`}
                >
                  📞 {j.phone}
                </a>
              </div>
            ),
            date: (
              <div className="d-grid ">
                <span className="text-[14px] text-gray-500 cursor-pointer">
                  Since:{" "}
                  <span className="font-medium">
                    {formatDate(j.createDate)}
                  </span>
                </span>
                {j.updateDate && (
                  <span className="text-[14px] text-gray-500 cursor-pointer">
                    Profile Last Update:{" "}
                    <span className="font-medium">
                      {formatDate(j.updateDate)}
                    </span>
                  </span>
                )}
              </div>
            ),
          };
        })}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Suppliers;
